import api from '@services/interceptor';
import { useWorkspaceStore } from '@stores/WorkspaceData';
import { toastService } from '@services/plugins/toast';
// План съёмки заявки: время съёмки, разворот, полётное задание (BST).
// Сейчас у заявки один план — создаётся сервером вместе с заявкой.
class PlanService {
  constructor(){
    this.wp = undefined
  }
  getWp(){
    if(!this.wp)this.wp = useWorkspaceStore()
    return this.wp
  }
  ids(plan){
    return {observationId: plan.observationId, planId: plan.id}
  }
  // Ошибки 400 сервер присылает с пояснением, чего не хватает для расчёта
  showError(error){
    console.log(error)
    if(error.response?.status !== 400) return
    const data = error.response.data
    const message = typeof data === 'string' ? data : (data?.message || data?.error || data?.detail)
    toastService.error(message || 'Некорректный запрос')
  }
  showWarning(response){
    const warning = response.headers?.['x-warning']
    if(warning) toastService.warn(decodeURIComponent(warning))
  }
  async Get(observationId){
    try {
      const response = await api.post(`/api/plans/${this.getWp().wpid}/list`, {observationId});
      return response.data?.[0] || null;
    } catch (error) {
      this.showError(error)
    }
    return null
  }
  async CalculateShootingTime(plan){
    try {
      const response = await api.post(`/api/plans/${this.getWp().wpid}/shooting-time/calculate`, this.ids(plan));
      this.showWarning(response)
      return response.data;
    } catch (error) {
      this.showError(error)
    }
  }
  async PutShootingTime(plan, shootingStart){
    try {
      const response = await api.put(`/api/plans/${this.getWp().wpid}/${plan.observationId}/${plan.id}/shooting-time`, {shootingStart});
      this.showWarning(response)
      return response.data;
    } catch (error) {
      this.showError(error)
    }
  }
  async PutTurnaround(plan, data){
    try {
      const response = await api.put(`/api/plans/${this.getWp().wpid}/${plan.observationId}/${plan.id}/turnaround`, data);
      return response.data;
    } catch (error) {
      this.showError(error)
    }
  }
  async CalculateTurnaround(plan){
    try {
      const response = await api.post(`/api/plans/${this.getWp().wpid}/turnaround/calculate`, this.ids(plan));
      return response.data;
    } catch (error) {
      this.showError(error)
    }
  }
  async CreateBST(plan){
    try {
      const response = await api.post(`/api/plans/${this.getWp().wpid}/bst`, this.ids(plan));
      return response.data;
    } catch (error) {
      this.showError(error)
    }
  }
  // Расчёты сбрасывают зависимые разделы плана — после изменений перечитываем план целиком
  async Reload(){
    const wp = this.getWp()
    if(!wp.experiment.Tar) return null
    wp.experiment.Plan = await this.Get(wp.experiment.Tar.id)
    // Результат моделирования считался по прежнему плану — он больше не актуален
    wp.simulation = null
    return wp.experiment.Plan
  }
}

export const planService = new PlanService();
